<script lang="ts">
    import {
        customerInfoProviderContextToken,
        gwI18nContextToken,
    } from "@/context_tokens";
    import { REVIEWER_NAME_DISPLAY_FORMAT } from "@apps/reviews/constants";
    import { formatCustomerName } from "@apps/reviews/utils/formatCustomerName";
    import { getTypedContext } from "@lib/svelte-typed-context";

    import Select from "@components/forms/Select/Select.svelte";

    export let isAuthenticated: boolean;
    export let namespace: string;
    export let value: string;

    const gwI18n = getTypedContext(gwI18nContextToken);
    const customerInfoProvider = getTypedContext(
        customerInfoProviderContextToken
    );

    const t_anonym$ = gwI18n.selectT(namespace, "anonym");
    const t_display_name_publicly_label$ = gwI18n.selectT(
        namespace,
        "display_name_publicly_label"
    );
    const firstName = customerInfoProvider.getFirstName();
    const lastName = customerInfoProvider.getLastName();

    const getReviewerDisplayNameList = (
        firstName: string,
        lastName: string,
        anonymLabel: string
    ) => {
        return [
            {
                label: formatCustomerName({
                    firstName,
                    lastName,
                    displayFormat: REVIEWER_NAME_DISPLAY_FORMAT.FULL_NAME,
                }),
                value: REVIEWER_NAME_DISPLAY_FORMAT.FULL_NAME,
            },
            {
                label: formatCustomerName({
                    firstName,
                    lastName,
                    displayFormat:
                        REVIEWER_NAME_DISPLAY_FORMAT.SHORTEN_LAST_NAME,
                }),
                value: REVIEWER_NAME_DISPLAY_FORMAT.SHORTEN_LAST_NAME,
            },
            {
                label: formatCustomerName({
                    firstName,
                    lastName,
                    displayFormat:
                        REVIEWER_NAME_DISPLAY_FORMAT.SHORTEN_FULL_NAME,
                }),
                value: REVIEWER_NAME_DISPLAY_FORMAT.SHORTEN_FULL_NAME,
            },
            {
                label: anonymLabel,
                value: REVIEWER_NAME_DISPLAY_FORMAT.ANONYMOUS,
            },
        ];
    };

    $: reviewerDisplayName =
        isAuthenticated && firstName && lastName
            ? getReviewerDisplayNameList(firstName, lastName, $t_anonym$)
            : getReviewerDisplayNameList("John", "Smith", $t_anonym$);
</script>

<Select
    label={$t_display_name_publicly_label$}
    items={reviewerDisplayName}
    value={value || REVIEWER_NAME_DISPLAY_FORMAT.FULL_NAME}
    on:change
/>
